import Cookies from 'js-cookie'

function setCookie (key, value, domain = 'mgzf.com') {
  if (window.location.hostname == 'localhost' || window.location.hostname.indexOf("192.168") > -1) {
    domain = ''
  }
  Cookies.set(key, value, {path: '/', domain: domain, expires: 1})
}

function getCookie (key, parseJson) {
  if (parseJson) {
    try {
      return JSON.parse(Cookies.get(key))
    }
    catch (ex) {
      return null
    }
  }
  return Cookies.get(key)
}

function delCookie (key, domain = 'mgzf.com') {
  if (window.location.hostname == 'localhost' || window.location.hostname.indexOf("192.168") > -1) {
    domain = ''
  }
  Cookies.remove(key, {path: '/', domain: domain})
}

export default {
  setCookie,
  getCookie,
  delCookie
}



// WEBPACK FOOTER //
// ./src/library/cookieUtil.js